import React, { Component } from 'react';


import Grid from '@material-ui/core/Grid';
import CardFenomene from './../../../fenomene_selection/components/CardFenomene';
import RangeComponent from './RangeComponent'

import { TIME_SELECTION_CONTAINER } from './../../../../../constants/strings/StringsDashboard';

class RangeSelect extends Component {
    render() {

        return (
            <Grid>
                <CardFenomene
                    title={TIME_SELECTION_CONTAINER.RANGE}
                    groupbutton={
                        <Grid>
                            <RangeComponent />
                        </Grid>
                    }
                />
            </Grid>
        )
    }
}

export default RangeSelect;